import { useEffect, useState } from 'react';
import { useAuth } from '../useAuth';
import { businessServicesConfig } from '../../services/businessServicesConfig';
import { updateGraphQLAuthHeader } from '../../services/graphql.service';
import { registry } from '../../features/extensions/instances';

export const useUpdateApiHeaders = (): {
  isHeadersUpdated: boolean;
} => {
  const { isAuthenticated, user } = useAuth();
  const accessToken = user?.accessToken;
  const [isHeadersUpdated, setIsHeadersUpdated] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !accessToken) {
      return;
    }

    businessServicesConfig.updateTokenGetter(() => `Bearer ${accessToken}`);
    updateGraphQLAuthHeader(`Bearer ${accessToken}`);
    registry.initApiClient(`Bearer ${accessToken}`);

    setIsHeadersUpdated(true);
  }, [isAuthenticated, accessToken]);

  return {
    isHeadersUpdated,
  };
};
